var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.309,
    height: 26.936,
    viewBox: "0 0 38.309 26.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube-2",
    "data-name": "Icon awesome-youtube",
    d: "M38.559,8.715a4.814,4.814,0,0,0-3.387-3.409C32.184,4.5,20.2,4.5,20.2,4.5s-11.98,0-14.967.806A4.814,4.814,0,0,0,1.85,8.715C1.05,11.722,1.05,18,1.05,18s0,6.274.8,9.281A4.742,4.742,0,0,0,5.237,30.63c2.988.806,14.967.806,14.967.806s11.98,0,14.967-.806a4.742,4.742,0,0,0,3.387-3.354c.8-3.007.8-9.281.8-9.281s0-6.274-.8-9.281ZM16.287,23.691V12.3L26.3,18l-10.013,5.7Z",
    transform: "translate(-1.05 -4.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fff78112f1b9f0cf6faa6e7be1b23f0f.svg";
export { ForwardRef as ReactComponent };